// global
import React, { Component, memo } from 'react';
import PropTypes from 'prop-types';
// local
// consts
// api
// views
import CustomDropdown from 'app/components/commons/dropdown/CustomDropdown';
import ErrorLabel from 'app/components/commons/label/ErrorLabel';

class LaborBondDropdown extends Component {
  state = {
    loading: true,
    options: []
  };

  componentDidMount() {
    this.setState({
      options: [
        { value: 1, text: 'CLT' },
        { value: 2, text: 'PN' },
        { value: 3, text: 'PJ' }
      ],
      loading: false
    });
  }

  render() {
    const { options, loading } = this.state;
    const {
      width,
      styleName,
      isForm,
      value,
      onChange,
      error,
      disabled,
      required,
      placeholder,
      label
    } = this.props;

    return (
      <CustomDropdown
        placeholder={placeholder}
        label={<ErrorLabel label={label} error={error} />}
        selection
        required={required}
        width={width}
        loading={loading}
        options={options}
        value={value}
        onChange={onChange}
        disabled={disabled}
        error={error ? true : false}
        styleName={styleName}
        isForm={isForm}
      />
    );
  }
}

LaborBondDropdown.defaultProps = {
  showSalvus: false,
  isForm: true,
  showLabel: true,
  label: 'Vínculo',
  placeholder: 'Vínculo'
};

LaborBondDropdown.propTypes = {
  width: PropTypes.number.isRequired,
  value: PropTypes.any,
  onChange: PropTypes.func,
  showSalvus: PropTypes.bool,
  disabled: PropTypes.bool,
  isForm: PropTypes.bool,
  filter: PropTypes.array,
  error: PropTypes.string,
  required: PropTypes.bool,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  styleName: PropTypes.string
};

export default memo(LaborBondDropdown);
